var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotScanned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 33,
    cy: 32.5,
    rx: 33,
    ry: 32.5,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.32 42H29.52L23.18 32.42V42H20.38V28.02H23.18L29.52 37.62V28.02H32.32V42ZM39.907 42.14C38.9337 42.14 38.0537 41.9733 37.267 41.64C36.4937 41.3067 35.8804 40.8267 35.427 40.2C34.9737 39.5733 34.7404 38.8333 34.727 37.98H37.727C37.767 38.5533 37.967 39.0067 38.327 39.34C38.7004 39.6733 39.207 39.84 39.847 39.84C40.5004 39.84 41.0137 39.6867 41.387 39.38C41.7604 39.06 41.947 38.6467 41.947 38.14C41.947 37.7267 41.8204 37.3867 41.567 37.12C41.3137 36.8533 40.9937 36.6467 40.607 36.5C40.2337 36.34 39.7137 36.1667 39.047 35.98C38.1404 35.7133 37.4004 35.4533 36.827 35.2C36.267 34.9333 35.7804 34.54 35.367 34.02C34.967 33.4867 34.767 32.78 34.767 31.9C34.767 31.0733 34.9737 30.3533 35.387 29.74C35.8004 29.1267 36.3804 28.66 37.127 28.34C37.8737 28.0067 38.727 27.84 39.687 27.84C41.127 27.84 42.2937 28.1933 43.187 28.9C44.0937 29.5933 44.5937 30.5667 44.687 31.82H41.607C41.5804 31.34 41.3737 30.9467 40.987 30.64C40.6137 30.32 40.1137 30.16 39.487 30.16C38.9404 30.16 38.5004 30.3 38.167 30.58C37.847 30.86 37.687 31.2667 37.687 31.8C37.687 32.1733 37.807 32.4867 38.047 32.74C38.3004 32.98 38.607 33.18 38.967 33.34C39.3404 33.4867 39.8604 33.66 40.527 33.86C41.4337 34.1267 42.1737 34.3933 42.747 34.66C43.3204 34.9267 43.8137 35.3267 44.227 35.86C44.6404 36.3933 44.847 37.0933 44.847 37.96C44.847 38.7067 44.6537 39.4 44.267 40.04C43.8804 40.68 43.3137 41.1933 42.567 41.58C41.8204 41.9533 40.9337 42.14 39.907 42.14Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotScanned);
export default __webpack_public_path__ + "static/media/NotScanned.9c6ea0729193dc6bdbe0f14c7a5701c2.svg";
export { ForwardRef as ReactComponent };